import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-section" }

import { ref, onMounted } from 'vue'
import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'
import SouscriptionWidget from '@/components/SouscriptionWidget.vue'
import walletService from '@/services/walletService'
import { formatAmount } from '@/utils/formatters'


export default /*@__PURE__*/_defineComponent({
  __name: 'WalletLayout',
  setup(__props) {

const balance = ref<number | null>(null)

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/wallet',
    icon: '/public/icons/icon-dashboard.svg',
    label: 'Wallet',
    exact: true,
    initialSidebarOpen: true
  },
  {
    to: '/front/wallet/utilisation',
    icon: '/public/icons/icon-utilisation.svg',
    label: 'Utilisation',
    initialSidebarOpen: true
  }
]

onMounted(async () => {
  try {
    const res = await walletService.getBalance()
    if (res.data) balance.value = res.data.balance || 0
  } catch (e) {
    // silencieux
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SectionSidebar, { "menu-items": menuItems }, {
      widget: _withCtx(() => [
        _createVNode(SouscriptionWidget)
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-space-50" }, null, -1)),
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})